<template>
  <a-modal centered :visible="visible" title="修改商标信息" @ok="on_submit" @cancel="cancel" :confirmLoading="submitting"
           :width="520">
    <a-form-model :model="form" ref="trademark_create" :rules="rules" layout="vertical">
      <a-form-model-item label="供货商价格" prop="price">
        <a-input v-model="form.price" allowClear />
      </a-form-model-item>

      <a-form-model-item label="售价" prop="sell_price">
        <a-input v-model="form.sell_price" allowClear />
      </a-form-model-item>

      <a-form-model-item label="供应商" prop="supplier_id">
        <a-input v-model="form.supplier_id" allowClear />
      </a-form-model-item>

      <a-form-model-item label="评分" prop="score">
        <a-rate v-model="form.score" />
      </a-form-model-item>

      <a-form-item name="tradestatus" label="商标状态" prop="tradestatus">
        <a-select v-model:value="form.tradestatus" :options="initTradestatus" />
      </a-form-item>

      <a-form-model-item label="商标图片" prop="imgUrl">
        <a-upload
            list-type="picture-card"
            name="file"
            :action="action"
            :withCredentials="true"
            :show-upload-list="false"
            @change="(info) => on_upload_change(info, 'imgUrl')"
            accept="image/png, image/jpeg"
        >
          <img v-if="form.imgUrl" :src="form.imgUrl" style="width:100%" />

          <div v-else>
            <a-icon :type="uploading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item label="效果图" prop="preview">
        <a-upload
            :action="action"
            @change="(info) => on_preview_change(info, 'preview')"
            accept="image/png, image/jpeg"
            :withCredentials="true"
            list-type="picture"
            class="upload-list-inline"
        >
          <a-button>
            上传效果图
          </a-button>
        </a-upload>
        <template>
          <div v-for="(file, index) in form.preview" :key="index">
            <img :src="file" alt="效果图" style="max-width: 200px; margin-bottom: 10px;" />
            <a-button type="danger"  @click="handleDeletePreview(file)">删除</a-button>
          </div>
        </template>
      </a-form-model-item>

      <a-form-model-item label="备注">
        <a-textarea v-model="form.remark" allowClear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import env from "../../../../env";

let init_form = {
  price: null,
  sell_price: null,
  supplier_id: null,
  remark: null,
  score: null,
  imgUrl: null,
  preview: [],
  tradestatus: null,
  stopSell: false
};
export default {
  props: {
    visible: {
      default: false
    },
    record: null,
    callback: null,
  },
  data() {
    return {
      initTradestatus : [
        { label: '已初审', value: '已初审' },
        { label: '已注册', value: '已注册' },
        { label: '已转让', value: '已转让' },
        { label: '已暂停', value: '已暂停' },
      ],
      uploading: false,
      action: env.base_url + "service/upload",
      submitting: false,
      form: {},
      rules: {
        contact_name: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入链接"
          }
        ],
        contact_tel: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "请输入联系电话"
          }
        ],
        supplier_id: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "必填"
          }
        ],
        tradestatus: [
          {
            required: true,
            trigger: ["change", "blur"],
            message: "必填"
          }
        ],
      }
    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(init_form));
  },
  watch: {
    visible(v) {
      if (v && this.record) {
        Object.keys(this.form).map((v) => {
          if (Object.prototype.hasOwnProperty.call(this.record, v)) {
            switch (v) {
              case "is_include_invoice":
              case "is_include_transfer":
              case "is_include_notary":
                this.form[v] = !!this.record[v];
                break;
              default:
                this.form[v] = this.record[v];
            }
          }
        });
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    on_submit() {
      this.$refs["trademark_create"].validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$http
            .put("/trademark/" + this.record.applyNo, this.form)
            .then((res) => {
              if (res.success) {
                this.form.preview = [];
                this.cancel();
                if (this.callback) {
                  this.callback(JSON.parse(JSON.stringify(this.form)));
                }
              } else {
                this.$error({ title: "失败", centered: true, content: res.message });
              }
            })
            .catch(() => {
            })
            .then(() => {
              this.submitting = false;
            });
        } else {
          this.$message.error("请检查并填写完需要录入的内容");
          return false;
        }
      });
    },

    after_close() {
      this.$refs["trademark_create"].resetFields();

      this.form = JSON.parse(JSON.stringify(init_form));
    },
    //效果图上传
    on_preview_change(info, field) {
      //删除
      if(info.file.status === "removed"){
        this.form.preview = this.form.preview.filter(item => item !== info.file.response.data.url);
      }
      if (info.file.status === "uploading") {
        this.uploading = true;
        return;
      }
      if (info.file.status === "done") {
        this.uploading = false;
        if (info.file.response.success) {
          this.form.preview.push(info.file.response.data.url);
        } else {
          this.$error({
            title: "失败",
            content: info.file.response.message,
          });
        }
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    //商标图片
    on_upload_change(info, field) {
      if (info.file.status === "uploading") {
        this.uploading = true;
        return;
      }
      if (info.file.status === "done") {
        this.uploading = false;
        if (info.file.response.success) {
          this.form[field] = info.file.response.data.url;
        } else {
          this.$error({
            title: "失败",
            content: info.file.response.message,
          });
        }
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    handleDeletePreview(file) {
      // 从fileList中移除指定文件
      const index = this.form.preview.indexOf(file);
      if (index !== -1) {
        this.form.preview.splice(index, 1);
      }
    },
  }
};
</script>
